import store from '@/app/app-state';

const WEBP_TEST_IMAGES = {
  lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
  lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
  alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
  // animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
};

export const isWebpSupported = async () => {
  const featureSupportResults = await Promise.all(Object.values(WEBP_TEST_IMAGES).map((image) => new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      const result = (img.width > 0) && (img.height > 0);
      if (result) {
        resolve(true);
      }
      resolve(false);
    };

    img.onerror = () => {
      resolve(false);
    };

    img.src = `data:image/webp;base64,${image}`;
  })));

  return featureSupportResults.every((result) => result === true);
};

export const toWebp = (path) => path.replace(/\.[^.]+$/, '.webp');

export const getWebpPathIfSupported = (path) => {
  if (!store.getters.isWebpSupported) {
    return path;
  }

  return toWebp(path);
};
